import { TIMER } from "../Gameplay";
import { Goalie, GoalieCatchAnim, GoalieMissAnim } from "./Goalie";



export abstract class CatchAnimBase {
    protected _goalie: Goalie;
    /**
     * Cas, kdy ma dojit ke spusteni animace
     */
    protected _animStartTime: number;
    /**
     * Jmeno animace
     */
    protected _animName: string;

    protected static readonly FLAG_ANIM_RUNNING = 1;
    protected _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(goalie: Goalie) {
        this._goalie = goalie;
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param ballPos Pozice, na ktere bude mic pri dosazeni Z pozice brankare
     * @param ballTime Cas, kdy mic dosahne pozice brankare
     * @param data 
     */
    //-------------------------------------------------------------------------
    abstract init(ballPos: pc.Vec2, ballTime: number, data: GoalieCatchAnim): void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if ((this._flags & CatchAnimBase.FLAG_ANIM_RUNNING) == 0) {
            // Cekat na spusteni animace
            if (TIMER.time >= this._animStartTime) {
                this._goalie.startAnimation(this._animName, 0.1, false);
                this._flags |= CatchAnimBase.FLAG_ANIM_RUNNING;
            }
        }
    }
}



export abstract class MissAnimBase {
    protected _goalie: Goalie;
    /**
     * Cas, kdy ma dojit ke spusteni animace
     */
    protected _animStartTime: number;
    /**
     * Jmeno animace
     */
    protected _animName: string;

    protected static readonly FLAG_ANIM_RUNNING = 1;
    protected _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(goalie: Goalie) {
        this._goalie = goalie;
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @param ballPos Pozice, na ktere bude mic pri dosazeni Z pozice brankare
     * @param ballTime Cas, kdy mic dosahne pozice brankare
     * @param data 
     */
    //-------------------------------------------------------------------------
    abstract init(ballPos: pc.Vec2, ballTime: number, data: GoalieMissAnim): void;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if ((this._flags & MissAnimBase.FLAG_ANIM_RUNNING) == 0) {
            // Cekat na spusteni animace
            if (TIMER.time >= this._animStartTime) {
                this._goalie.startAnimation(this._animName, 0.1, false);
                this._flags |= MissAnimBase.FLAG_ANIM_RUNNING;
            }
        }
    }
}